export const BENE_V3_FIELDS = {
  payout_method: '',
  beneficiary_identification_type: '',
  beneficiary_identification_value: '',
  is_legal_last_name_provided: false
};

export const ADDRESS_FIELDS = [
  'unit_number',
  'street_number',
  'street',
  'street_name',
  'street_type',
  'suburb',
  'state',
  'block_number',
  'floor_number',
  'building_name',
  'district',
  'address1',
  'address2',
  'city',
  'postcode',
  'building_number',
  'province'
];
